"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var SpeisekarteModel_1 = require("../models/SpeisekarteModel");
var Kopfzeile_1 = require("./Kopfzeile");
var NeuerKopf_1 = require("./CustomPanel/NeuerKopf");
var Speisekarte = /** @class */ (function (_super) {
    __extends(Speisekarte, _super);
    function Speisekarte(props) {
        var _this = _super.call(this, props) || this;
        _this.KopfHandling = React.createRef();
        _this.addNewHead = function (data, isLeft) {
            var temp = JSON.parse(JSON.stringify(data));
            var startLeft = Math.max.apply(Math, __spreadArrays(_this.state.data[_this.state.data.length - 1].smallHeadlineLeft.map(function (o) { return o.startIndex; }), [0])) + 1000;
            var startRight = Math.max.apply(Math, __spreadArrays(_this.state.data[_this.state.data.length - 1].smallHeadlineRight.map(function (o) { return o.startIndex; }), [0])) + 1000;
            var newHead = new SpeisekarteModel_1.SmallHeadline();
            newHead.startIndex = startLeft > startRight ? startLeft : startRight;
            newHead.value = null;
            newHead.additionalValue = null;
            newHead.subText = null;
            newHead.dishes = [];
            newHead.categorie = "Speise";
            newHead.additionals = [];
            newHead.dishes = null;
            if (isLeft)
                temp.smallHeadlineLeft.push(newHead);
            else
                temp.smallHeadlineRight.push(newHead);
            _this.setState({ newData: temp });
            _this.KopfHandling.current.updateData(newHead);
        };
        _this.ConfirmedHeadEvent = function (head) {
            if (head !== null) {
                var newArray_1 = _this.setData(_this.state.data, _this.state.newData);
                _this.saveData("Speise/Karte/Post", newArray_1)
                    .then(function () { return _this.setState({ data: newArray_1 }); });
            }
            _this.KopfHandling.current.closeDialog();
        };
        _this.setData = function (data, newData) {
            var newList = data.map(function (item) {
                if (item.headLine === newData.headLine) {
                    var updatedItem = __assign(__assign({}, item), { smallHeadlineLeft: newData.smallHeadlineLeft, smallHeadlineRight: newData.smallHeadlineRight });
                    return updatedItem;
                }
                return item;
            });
            return newList;
        };
        _this.ReorderEvent = function (data) {
            var newArray = __spreadArrays(_this.state.data);
            newArray.forEach(function (x) {
                if (x.smallHeadlineLeft !== null)
                    x.smallHeadlineLeft.forEach(function (y) {
                        if (y.startIndex === data.startIndex)
                            y = data;
                    });
                if (x.smallHeadlineRight !== null)
                    x.smallHeadlineRight.forEach(function (y) {
                        if (y.startIndex === data.startIndex)
                            y = data;
                    });
            });
            _this.saveData("Speise/Karte/Post", newArray)
                .then(function () { return _this.setState({ data: newArray }); });
        };
        _this.state = { data: [], newData: new SpeisekarteModel_1.default(), additive: [] };
        _this.getData("Zusatz/Stoffe/Get")
            .then(function (data) {
            _this.setState({ additive: data });
            _this.getData("Speise/Karte/Get")
                .then(function (data) { return _this.setState({ data: data }); });
        });
        return _this;
    }
    Speisekarte.prototype.render = function () {
        var _this = this;
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement("div", null,
            React.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
                this.state.data.map(function (header, index) {
                    var _a, _b;
                    return React.createElement(reactstrap_1.Container, { key: index, style: index % 2 !== 0 ? { backgroundColor: "#80808024" } : {} },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { md: 6, style: { paddingBottom: "15px" } },
                                header.smallHeadlineLeft !== null && ((_a = header.smallHeadlineLeft) === null || _a === void 0 ? void 0 : _a.map(function (left, i) {
                                    return React.createElement(Kopfzeile_1.default, { smallHeadline: left, isLeft: true, key: "Left" + left.startIndex, isAdmin: _this.props.isAdmin, index: left.startIndex, reorderEvent: _this.ReorderEvent, additive: _this.state.additive });
                                })),
                                _this.props.isAdmin &&
                                    React.createElement(reactstrap_1.Col, { style: { paddingLeft: "50%", paddingRight: "50%" } },
                                        React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Neu", ariaLabel: "Neu", onClick: function () { return _this.addNewHead(header, true); } }))),
                            React.createElement(reactstrap_1.Col, { md: 6, style: { paddingBottom: "15px" } },
                                header.smallHeadlineRight !== null && ((_b = header.smallHeadlineRight) === null || _b === void 0 ? void 0 : _b.map(function (right, i) {
                                    return React.createElement(Kopfzeile_1.default, { smallHeadline: right, isLeft: false, key: "Right" + right.startIndex, isAdmin: _this.props.isAdmin, index: right.startIndex, reorderEvent: _this.ReorderEvent, additive: _this.state.additive });
                                })),
                                _this.props.isAdmin &&
                                    React.createElement(reactstrap_1.Col, { style: { paddingLeft: "50%", paddingRight: "50%" } },
                                        React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Neu", ariaLabel: "Neu", onClick: function () { return _this.addNewHead(header, false); } })))));
                }),
                React.createElement(reactstrap_1.Container, null,
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.Container, { style: { margin: 0, padding: 0 } },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { md: 12 },
                                        React.createElement("div", { style: { display: "flex" } },
                                            React.createElement("div", { style: { width: "100%", clear: "both" } },
                                                React.createElement("div", { style: { float: "left", fontSize: "15px", fontWeight: 600, color: "rgb(84 82 82 / 94%)" } }, "Zusatzstoffe:")))),
                                    React.createElement(reactstrap_1.Col, { md: 12, style: { fontSize: "15px", fontWeight: 300, color: "rgb(84 82 82 / 94%)" } }, this.state.additive !== null && this.state.additive.map(function (additives, i) {
                                        return React.createElement("span", null,
                                            React.createElement("span", null, additives.text !== "" ? additives.key : ""),
                                            React.createElement("span", null, additives.text !== "" ? "=" : ""),
                                            React.createElement("span", null, additives.text !== "" ? additives.text : ""),
                                            React.createElement("span", null, i + 1 !== _this.state.additive.length && additives.text !== "" ? ", " : ""));
                                    })))))))),
            React.createElement(NeuerKopf_1.default, { confirmedEvent: this.ConfirmedHeadEvent, ref: this.KopfHandling })));
    };
    Speisekarte.prototype.saveData = function (url, data) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                fetch('api/' + url, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                    }),
                    method: 'post',
                    body: JSON.stringify(data)
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                });
                return [2 /*return*/];
            });
        }); });
    };
    Speisekarte.prototype.getData = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                fetch('api/' + url, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                    })
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) { return resolve(data); })
                    .catch(function (error) { return reject(error); });
                return [2 /*return*/];
            });
        }); });
    };
    return Speisekarte;
}(React.Component));
exports.default = Speisekarte;
//# sourceMappingURL=Speisekarte.js.map